import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GuestModeService } from 'src/app/core/services/guest-mode/guest-mode.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
})
export class LayoutComponent implements OnInit {
  isGuestMode = false;

  constructor(
    private route: ActivatedRoute,
    private guestModeService: GuestModeService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.guestModeService.guestMode$.subscribe(isGuest => {
      this.isGuestMode = isGuest;
      this.cdr.detectChanges();
    });

    this.route.queryParams.subscribe(params => {
      if (params['guestMode'] === 'true') {
        this.guestModeService.setGuestMode(true);
      }
    });
  }
}
